<template>
  <div style="overflow-y: auto;height: 500px;margin-top: 20px;">
    <div v-if="applicationSelected" class="application-view">
      <AdminApplicationView :application="applicationSelected" :lov="lov" :close="closeDetailView" />
    </div>
    <div v-if="applications">
      <h2>Applications</h2>
      <div class="description">Student applications view</div>

      <div class="table">
        <div class="trow">
          <div class="thead application">Application</div>
          <div class="thead picked-by">Picked By</div>
          <div class="thead actions">Actions</div>
        </div>
        <div class="trow" v-for="application in applications" :key="application.id">
          <div class="tdata application">
            <div>{{application.name}}</div>
            <div>{{application.school.name}} - {{application.school.province}}</div>
          </div>
          <div class="tdata picked-by">
            <div v-if="!application.picked_by"> -- </div>
            <div v-if="application.picked_by">
              <div>{{application.picked_by.full_name}}</div>
              <div>{{application.picked_by.email}}</div>
            </div>
          </div>
          <div class="tdata actions">
            <v-button type="primary" size="small" @click="() => showApplicationDetails(application)">View Details</v-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdminApplicationView from './AdminApplicationView'

export default {
  name: 'ViewApplications',
  data () {
    return {
      applicationSelected: null
    }
  },
  computed: {
    ...mapGetters([
      'applications',
      'lov'
    ])
  },
  watch: {
    directApplications: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getApplications', 'Applied')
        }
      },
      immediate: true
    },
    lov: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getLov')
        }
      },
      immediate: true
    }
  },
  methods: {
    showApplicationDetails (application) {
      this.applicationSelected = application
    },
    closeDetailView () {
      this.applicationSelected = null
    }
  },
  components: {
    AdminApplicationView
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 24px;
}
.table {
  width: 100%;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 15px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 13px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
}
.trow .application {
  width: 40%;
}
.trow .picked-by {
  width: 35%;
}
.trow .actions {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-tabs-content.ant-tabs-content-animated > div:not(:first-child) {
  margin-left: 0px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Applications/ViewApplications.vue